module.exports = __webpack_public_path__ + "img/at-valuations.21c33aa9.png";